export const linkWidth = '0.5px';
export const linkColor = '#bdbdbd';
export const nodesCirclesRadius = 5;
export const nodesCirclesColor = '#5c5c5c';
export const nodeDistance = 250;
export const labelDistance = 15;
export const mobileScreenHeight = 860;
